import { render, staticRenderFns } from "./FifthShow.vue?vue&type=template&id=5f3d3fdf&scoped=true"
import script from "./FifthShow.vue?vue&type=script&lang=js"
export * from "./FifthShow.vue?vue&type=script&lang=js"
import style0 from "./FifthShow.vue?vue&type=style&index=0&id=5f3d3fdf&prod&lang=less&scoped=true"
import style1 from "./FifthShow.vue?vue&type=style&index=1&id=5f3d3fdf&prod&scoped=true&lang=css"
import style2 from "./FifthShow.vue?vue&type=style&index=2&id=5f3d3fdf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3d3fdf",
  null
  
)

export default component.exports